export default __webpack_public_path__ + "static/pipeline-3d82d1664a55037387108865f43c19ca.png";